export default "__VITE_ASSET__BaAPIm3P__"